import React from "react";
import { Col, Row } from "antd";

function CardHeader(props) {
    return (
        <Row style={{ display: "flex", alignItems: "center" }}>
            <Col span={12}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                        <h2 className={"dados-header"}>Notificações</h2>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default CardHeader;
